import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function TopBar() {
  return <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-3 px-4 z-50 shadow-lg" data-id="element-164">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 text-sm md:text-base" data-id="element-165">
        <span className="font-semibold" data-id="element-166">⚠️ Esta oferta termina pronto</span>
        <CountdownTimer className="text-lg" data-id="element-167" />
      </div>
    </div>;
}